export const DOCUMENT_TYPE_PAY_TAX = 'directive_to_pay_tax';
export const DOCUMENT_TYPE_RELEASE = 'notification_to_release_monies';
export const DOCUMENT_TYPE_UNKNOWN = 'unknown';

export const DOCUMENT_TYPE_OPTIONS = [
  { id: DOCUMENT_TYPE_PAY_TAX, label: 'Directive to Pay Tax' },
  { id: DOCUMENT_TYPE_RELEASE, label: 'Notification to Release Monies' },
  { id: DOCUMENT_TYPE_UNKNOWN, label: 'Unknown — confirm from letter' },
];

export const OUTCOME_FROM_DOCUMENT_TYPE = {
  [DOCUMENT_TYPE_PAY_TAX]: 'pay_tax',
  [DOCUMENT_TYPE_RELEASE]: 'release',
  [DOCUMENT_TYPE_UNKNOWN]: '',
};

export const formatSgd = (amount) => {
  const numeric = Number(amount);
  if (!Number.isFinite(numeric)) return '0.00';
  return numeric.toFixed(2);
};

export const payrollEffectCopy = ({
  outcome,
  amount,
  alreadyDisbursed = false,
} = {}) => {
  const amountText = formatSgd(amount);
  if (outcome === 'pay_tax' && alreadyDisbursed) {
    return {
      tone: 'blocking',
      title: 'Manual Finance recovery required',
      body: `Final salary has already been paid. Finance must recover SGD ${amountText} from the employee. This will not create an automatic payroll deduction.`,
    };
  }
  if (outcome === 'pay_tax') {
    return {
      tone: 'deduct',
      title: 'Payroll effect',
      body: `Deduct SGD ${amountText} from the withheld final payment and remit it to IRAS`,
    };
  }
  if (outcome === 'release') {
    return {
      tone: 'release',
      title: 'Payroll effect',
      body: 'No deduction; release all withheld monies.',
    };
  }
  return {
    tone: 'unknown',
    title: 'Payroll effect',
    body: 'Verify the letter type before confirming.',
  };
};

export const mapOcrToForm = (document) => {
  const source = document || {};
  const proposed = source.proposed_directive || {};
  const extracted = source.extracted_document || {};
  const documentType = proposed.document_type || extracted.ocr_document_type || DOCUMENT_TYPE_UNKNOWN;
  const outcome = proposed.outcome || OUTCOME_FROM_DOCUMENT_TYPE[documentType] || '';
  return {
    documentType,
    outcome,
    directiveDate: proposed.directive_date || extracted.ocr_letter_date || '',
    reference: proposed.reference || extracted.ocr_iras_document_reference || extracted.ocr_tax_reference_number || '',
    amount: proposed.amount || extracted.ocr_tax_amount || '',
    dueDate: proposed.due_date || extracted.ocr_payment_due_date || '',
    paymentSlipNumber: proposed.payment_slip_number || extracted.ocr_payment_slip_number || '',
    employeeName: extracted.ocr_employee_name || '',
    employeeFin: extracted.ocr_employee_fin || '',
  };
};

export const canSubmitVerifiedDirective = (evidence) => Boolean(
  evidence?.documentId
  && (evidence.outcome === 'pay_tax' || evidence.outcome === 'release')
  && evidence.directiveDate
  && String(evidence.reference || '').trim()
  && (
    evidence.outcome !== 'pay_tax'
    || (evidence.amount !== '' && Number(evidence.amount) >= 0)
  ),
);

export const isReviewableIR21Document = (document) => {
  const status = document?.verification_status;
  return status === 'verification_required' || status === 'failed' || status === 'pending_ocr';
};
